import React from 'react';
import { components } from 'react-select';
import { IconChevronDown, IconClose, IconCheck, IconCheckFilled, IconChevronUp } from '@ch/common/components/icon';

export const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="react-select__dropdown-indicator-inner">
        {props?.selectProps?.menuIsOpen ? (
          <IconChevronUp $size={10} $color="primary" />
        ) : (
          <IconChevronDown $size={9} $color="primary" />
        )}
      </span>
    </components.DropdownIndicator>
  );
};

export const ClearIndicator = (props: any) => {
  return (
    <components.ClearIndicator {...props}>
      <span className="react-select__clear-btn">
        <IconClose $size={10} $color="black" />
      </span>
    </components.ClearIndicator>
  );
};

export const NoOptionsMessage = (props: any) => {
  return (
    <components.NoOptionsMessage {...props}>
      <span className="react-select__no-result">No results found</span>
    </components.NoOptionsMessage>
  );
};

export const OptionBasic = (props: any) => {
  const { ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };
  return (
    <components.Option {...newProps}>
      {props.children}
      <span className="react-select__check-ico">
        <IconCheckFilled $size={25} $color="success" $isOuterLayerExist={false} />
      </span>
    </components.Option>
  );
};

export const OptionMultiple = (props: any) => {
  return (
    <components.Option {...props}>
      <span className="react-select-creatable__check-block">
        <IconCheck $size={8} />
      </span>
      {props.children}
    </components.Option>
  );
};

export const MultiValueRemove = (props: any) => {
  return (
    <components.MultiValueRemove {...props}>
      <IconClose $size={10} $color="white" />
    </components.MultiValueRemove>
  );
};
